import { cookies } from "../CookiesHandler/cookies"

export const extractDescriptionFromCategory = (category) => {
    const currentLang = cookies.get('i18next');

    const description = ( currentLang === 'it' ) ? "description" : "descriptionEN";
    const descriptionALT = ( currentLang === 'it' ) ? "descriptionEN":"description";

    if (category[description] || category[descriptionALT]) {
        let descriptionSlices = (category[description] || category[descriptionALT]).split('\\').filter(
            (slice) => {
                return slice.length > 0
            }
        )
        return descriptionSlices
    } else {
        if (!(category[description] || category[descriptionALT])) {
            return null
        }
    }
}

export const extractFootnoteFromCategory = (category) => {
    const currentLang = cookies.get('i18next');

    const footnote = ( currentLang === 'it' ) ? "footNote" : "footNoteEN";
    const footnoteAlt = ( currentLang === 'it' ) ? "footNoteEN":"footNote";

    if (category[footnote] || category[footnoteAlt]) {
        let descriptionSlices = (category[footnote] || category[footnoteAlt]).split('\\').filter(
            (slice) => {
                return slice.length > 0
            }
        )
        return descriptionSlices
    } else {
        if (!(category[footnote] || category[footnoteAlt])) {
            return null
        }
    }
}

export const extractNameFromCategory = (category) => {
    const currentLang = cookies.get('i18next');

    const name = ( currentLang === 'it' ) ? "name" : "nameEN";
    const nameAlt = ( currentLang === 'it' ) ? "nameEN":"name";

    return category[name] || category[nameAlt]
}



export const extractNameFromMenuItem = (menuItem) => {
    const currentLang = cookies.get('i18next');

    const name = ( currentLang === 'it' ) ? "name" : "nameEN";
    const nameAlt = ( currentLang === 'it' ) ? "nameEN":"name";

    return menuItem[name] || menuItem[nameAlt]
}


export const extractDescriptionFromMenuItem = (menuItem) => {
    const currentLang = cookies.get('i18next');

    const description = ( currentLang === 'it' ) ? "description" : "descriptionEN";
    const descriptionALT = ( currentLang === 'it' ) ? "descriptionEN":"description";

    return menuItem[description] || menuItem[descriptionALT]

}

export const extractNameFromMenuItemKey = (menuItemKey, categoryKey, dishesLookupTable) => {
    const currentLang = cookies.get('i18next');

    const name = ( currentLang === 'it' ) ? "name" : "nameEN";
    const nameAlt = ( currentLang === 'it' ) ? "nameEN":"name";

    return ((dishesLookupTable[categoryKey] ?? {})[menuItemKey] ?? {})[name] || ((dishesLookupTable[categoryKey] ?? {})[menuItemKey] ?? {})[nameAlt];
}


export const extractDescriptionFromMenuItemKey = (menuItemKey, categoryKey, dishesLookupTable) => {
    const currentLang = cookies.get('i18next');

    const description = ( currentLang === 'it' ) ? "description" : "descriptionEN";
    const descriptionALT = ( currentLang === 'it' ) ? "descriptionEN":"description";

    return ((dishesLookupTable[categoryKey] ?? {})[menuItemKey] ?? {})[description] || ((dishesLookupTable[categoryKey] ?? {})[menuItemKey] ?? {})[descriptionALT];
}

export const extractGastronomicMatchesForDish = (dish) => {
    const currentLang = cookies.get('i18next');

    const gastronomicMatches = ( currentLang === 'it' ) ? "gastronomicMatches" : "gastronomicMatchesEN";
    const gastronomicMatchesALT = ( currentLang === 'it' ) ? "gastronomicMatchesEN":"gastronomicMatches";

    return dish[gastronomicMatches] ?? dish[gastronomicMatchesALT]
}

export const extractTechnicalitiesForDish = (dish) => {
    const currentLang = cookies.get('i18next');

    const technicalities = ( currentLang === 'it' ) ? "technicalities" : "technicalitiesEN";
    const technicalitiesALT = ( currentLang === 'it' ) ? "technicalitiesEN":"gastronomicMatches";

    return dish[technicalities] ?? dish[technicalitiesALT]
}